/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrganizationStateTown } from './OrganizationStateTown';
import {
    OrganizationStateTownFromJSON,
    OrganizationStateTownFromJSONTyped,
    OrganizationStateTownToJSON,
    OrganizationStateTownToJSONTyped,
} from './OrganizationStateTown';

/**
 * 
 * @export
 * @interface SwitchOrganizationStateTownType200Response
 */
export interface SwitchOrganizationStateTownType200Response {
    /**
     * 
     */
    data?: OrganizationStateTown;
}

/**
 * Check if a given object implements the SwitchOrganizationStateTownType200Response interface.
 */
export function instanceOfSwitchOrganizationStateTownType200Response(value: object): value is SwitchOrganizationStateTownType200Response {
    return true;
}

export function SwitchOrganizationStateTownType200ResponseFromJSON(json: any): SwitchOrganizationStateTownType200Response {
    return SwitchOrganizationStateTownType200ResponseFromJSONTyped(json, false);
}

export function SwitchOrganizationStateTownType200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SwitchOrganizationStateTownType200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : OrganizationStateTownFromJSON(json['data']),
    };
}

export function SwitchOrganizationStateTownType200ResponseToJSON(json: any): SwitchOrganizationStateTownType200Response {
    return SwitchOrganizationStateTownType200ResponseToJSONTyped(json, false);
}

export function SwitchOrganizationStateTownType200ResponseToJSONTyped(value?: SwitchOrganizationStateTownType200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': OrganizationStateTownToJSON(value['data']),
    };
}

